module.exports = __webpack_public_path__ + "img/bg8.739ea1bc.jpg";